import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export type PaymentCardSetupIntentResponseModel = {
	readonly setupIntentClientSecret: string;
};

export const usePaymentCardSetupIntent = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<PaymentCardSetupIntentResponseModel>> = () => {
		return http({
			method: "POST",
			url: "/stripe/setup-intent",
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn
	});
};
